export const actionTypes = {
  REQUEST_START: 'APP.ADMIN_CONFIG.REQUEST_START',
  REQUEST_SUCCESS: 'APP.ADMIN_CONFIG.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.ADMIN_CONFIG.REQUEST_FAILURE',
};

export function startRequest(type) {
  return {
    type: actionTypes.REQUEST_START,
    payload: type,
  };
}

export function requestSuccess({ data, type }) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: {
      data,
      type,
    },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
